import { TRANSACTION_TYPE_FILTERS } from '../../../assets/constants/historyData';
import {
  DEFAULT_HORIZONTAL_PANEL_DIRECTION,
  getIndexedHorizontalPanelDirection,
  HORIZONTAL_PANEL_TRANSITION,
  HORIZONTAL_PANEL_VARIANTS,
} from '../../shared/motion/horizontalPanelMotion';

export const DEFAULT_HISTORY_LIST_TRANSITION = DEFAULT_HORIZONTAL_PANEL_DIRECTION;

export const HISTORY_PANEL_TRANSITION = HORIZONTAL_PANEL_TRANSITION;

const HISTORY_TYPE_FILTER_POSITION = Object.freeze({
  [TRANSACTION_TYPE_FILTERS.EXPENSE]: -1,
  [TRANSACTION_TYPE_FILTERS.ALL]: 0,
  [TRANSACTION_TYPE_FILTERS.INCOME]: 1,
});

export const HISTORY_LIST_VARIANTS = HORIZONTAL_PANEL_VARIANTS;

export function getHistoryListTransition(currentType, nextType) {
  const currentPosition = HISTORY_TYPE_FILTER_POSITION[currentType] ?? 0;
  const nextPosition = HISTORY_TYPE_FILTER_POSITION[nextType] ?? 0;

  return getIndexedHorizontalPanelDirection(currentPosition, nextPosition);
}
